module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_tulip-d9bf606fdca398857bcf3de8336b54ae.png";